import { FC, useContext } from "react";
import { img } from "../../assets/icon";
import {
  QuizContext,
  TextConfig,
} from "../../providers/QuizProvider/QuizContext";
import { getStyleFromTextConfig } from "../../utils/style";
import { Bonuses } from "../Bonuses/Bonuses";
import { Button } from "../Button/Button";
import { Discount } from "../Discount/Discount";
import { LayoutStartPage } from "../LayoutStartPage/LayoutStartPage";
import { TextLabel } from "../TextLabel/TextLabel";
import {
  Image,
  Thumb,
  Title,
  Text,
  Wraper,
  BoxText,
  BoxBonuse,
  TextTitle,
  BoxContainer,
} from "./WelcomePage.styled";
import { Mobile } from "../Container/Mobile";
import { Desktop } from "../Container/Desktop";
import { useTranslation } from "../../hooks/useTranslation";

type Props = {
  title: string;
  titleConfig: TextConfig;
  description: string;
  descriptionConfig: TextConfig;
  buttonText?: string;
  buttonTextConfig?: TextConfig;
  image?: string | null;
  isHideButton?: boolean;
  isShowAdditions: boolean;
  //additionPageDisplay: number;
  additionsWithoutConsultant?: any[];
  onStart?: () => void;
  lockBonus: boolean;
};

export const WelcomPage: FC<Props> = ({
  title,
  titleConfig,
  description,
  descriptionConfig,
  buttonText,
  buttonTextConfig,
  image,
  isHideButton = false,
  isShowAdditions,
  additionsWithoutConsultant = [],
  onStart,
  lockBonus,
}) => {
  const { t } = useTranslation();

  const { design_type } = useContext(QuizContext);

  return (
    <LayoutStartPage design_type={design_type} image={image ? image : img}>
      <Thumb design_type={design_type}>
        <Image src={image ? image : img} design_type={design_type} alt="img" />
        <Desktop>
          <TextLabel design_type={design_type} />
        </Desktop>
      </Thumb>
      <Wraper design_type={design_type}>
        {(design_type === 5 || design_type === 6) && (
          <Desktop>
            <TextLabel design_type={design_type} />
          </Desktop>
        )}
        <BoxText design_type={design_type}>
          <Title style={getStyleFromTextConfig(titleConfig)}>{title}</Title>
          <Text style={getStyleFromTextConfig(descriptionConfig)}>
            {description}
          </Text>
          {!isHideButton && (
            <Button
              onNext={onStart}
              title={buttonText ?? t("nextBtn")}
              isHideArrow={true}
              titleConfig={buttonTextConfig}
            />
          )}
        </BoxText>
        {isShowAdditions && (
          <BoxContainer design_type={design_type}>
            {additionsWithoutConsultant.length > 0 && (
              <>
                <TextTitle>{t("getYourBonus")}</TextTitle>
                <BoxBonuse>
                  {additionsWithoutConsultant.map((item) =>
                    item.type === 2 ? (
                      <Discount key={item.id} addition={item} lockBonus={lockBonus} />
                    ) : (
                      <Bonuses
                        key={item.id}
                        addition={item}
                        lockBonus={lockBonus}
                      />
                    )
                  )}
                </BoxBonuse>
              </>
            )}
          </BoxContainer>
        )}
        <Mobile>
          <TextLabel design_type={design_type} />
        </Mobile>
      </Wraper>
      {(design_type === 3 || design_type === 4) && (
        <Desktop>
          <TextLabel design_type={design_type} />
        </Desktop>
      )}
    </LayoutStartPage>
  );
};
